import Mock from 'mockjs'

import dashboardAPI from './dashboard'


Mock.mock(/\/dashboard\/upLeft/, 'post', dashboardAPI.upLeft)
Mock.mock(/\/dashboard\/left/, 'post', dashboardAPI.left)
Mock.mock(/\/dashboard\/upright/, 'post', dashboardAPI.upright)
Mock.mock(/\/dashboard\/right/, 'post', dashboardAPI.right)
Mock.mock(/\/dashboard\/lowleft/, 'post', dashboardAPI.lowleft)
Mock.mock(/\/dashboard\/getTotalMoney/, 'post', dashboardAPI.getTotalMoney)
Mock.mock(/\/dashboard\/queryFreq/, 'post', dashboardAPI.queryFreq)
Mock.mock(/\/dashboard\/getAppNum/, 'post', dashboardAPI.getAppNum)

export default Mock


// WEBPACK FOOTER //
// ./src/mock/index.js